<template>
  <div class="card-float">
    <slot />
  </div>
</template>

<script>
export default {
  name: "CardFloat",
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.card-float {
  position: absolute;
  left: 0;
  bottom: calc(100% + 20px);
}
</style>
